import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable';

window.RentIndexPDF = {
    doc: null,
    startY: 10,
    y: 10,
    cityName: "",
    date: "",
    rentBuy: "miete",
    fontName: "helvetica",

    init: function () {
        if (jQuery('.rentindex-pdf').length > 0) {
            if (pdfData.sizeDataWhg.length <= 0 && jQuery('.chart-rent_whg_bar').length <= 0 && pdfData.sizeDataWhgYears.length <= 0 && jQuery('.chart-rent_whg').length <= 0 && pdfData.whgDistrictPrices.length <= 0
                && pdfData.sizeDataHaus.length <= 0 && jQuery('.chart-rent_haus_bar').length <= 0 && pdfData.sizeDataHausYears.length <= 0 && jQuery('.chart-rent_haus').length <= 0 && pdfData.hausDistrictPrices.length <= 0) {
                jQuery('.rentindex-pdf').hide();
            }
        }
    },

    downloadRentIndex: function (name, data, rentBuy) {
        if (rentBuy === undefined) {
            rentBuy = "miete";
        }

        this.rentBuy = rentBuy;
        window.RentIndexPDF.doc = new jsPDF();
        var doc = window.RentIndexPDF.doc;
        var col1 = 10;
        var col2 = 100;
        this.y = this.startY;
        var empty = true;

        var mietspiegel = (rentBuy === "miete" ? 'Mietspiegel' : 'Immobilienpreisspiegel');

        doc.pageCount = 1;
        this.headlineStyle();
        doc.text(mietspiegel + ' ' + data.city_name + ' - ' + data.month + '/' + data.year, col1, this.y);
        this.cityName = data.city_name;
        this.date = data.lastDayOfMonth+'.'+data.month + '.' + data.year;
        this.textStyle();
        this._y(this.y + 10);
        if (rentBuy === "miete") {
            doc.text('Unsere Mietspiegel werden fortlaufend aktualisiert '+data.latestUpdateStr+'.\nDer durchschnittliche Mietpreis in ' + data.city_name + ' liegt bei ' + data.avg_rent_price + '.', col1, this.y);
            this._y(this.y + 15);
            this.headlineSmallStyle();
            doc.text('Bitte beachte!', col1, this.y);
            this._y(this.y + 5);
            this.textStyle();
            doc.text('Die hier abrufbaren Informationen zur Mietpreisentwicklung in Deutschland werden nicht von einer Gemeinde oder Interessenvertretern\nerstellt oder anerkannt, sondern basieren allein auf einer Auswertung der in unserem Immobilienportal\nwww.wohnungsboerse.net gelisteten Mietwohnungen. ', col1, this.y);
            this._y(this.y + 15);
            doc.text('Da jede Wohnung sich von dem Baujahr, der Wohnlage und Ausstattung unterscheidet, sind diese Mietspiegel\nkeine Grundlage für die exakte Berechnung des Mietpreises pro m², sondern dienen nur als Anhaltspunkt.\nWende dich sich bitte an die örtliche Gemeinde um einen anerkannten Mietspiegel für die Berechnung des genauen\nQuadratmeterpreises einer Wohnung zu erhalten.', col1, this.y);
            this._y(this.y + 20);
            doc.text('Die Mietpreise werden anhand der Kaltmiete (auch Nettomiete, Nettokaltmiete oder Grundmiete) berechnet.\nHeizkosten oder sog. kalte Betriebskosten sind nicht in der Nettokaltmiete enthaten. ', col1, this.y);
            this._y(this.y + 5);
        } else {
            doc.text('Unsere Immobilienpreisspiegel werden fortlaufend aktualisiert '+data.latestUpdateStr+'.\nDer durchschnittliche Kaufpreis in ' + data.city_name + ' liegt bei ' + data.avg_rent_price + '.', col1, this.y);
            this._y(this.y + 15);
            this.headlineSmallStyle();
            doc.text('Bitte beachten Sie!', col1, this.y);
            this._y(this.y + 5);
            this.textStyle();
            doc.text('Der Wohnungsbörse - Immobilienpreisspiegel von ' + data.city_name + ' wurde nicht von einer Gemeinde oder Interessenvertretern\nerstellt oder anerkannt, sondern basiert allein auf einer Auswertung der in unserem Immobilienportal \nwww.wohnungsboerse.net gelisteten Immobilien.', col1, this.y);
            this._y(this.y + 15);
            doc.text('Da sich jede Immobilie im Baujahr, der Wohnlage und Ausstattung unterscheidet, sind diese Immobilienpreise\nkeine Grundlage für eine exakte Berechnung des Quadratmeterpreises, sondern dienen nur als Anhaltspunkt.\nWenden Sie sich bitte an die örtliche Gemeinde um einen anerkannten Immobilienpreisspiegel für die Berechnung\ndes genauen Wohnungspreises einer Immobilie zu erhalten.', col1, this.y);
            this._y(this.y + 5);
        }

        // Wohnungen
        this._y(this.y + 20);
        if (data.sizeDataWhg.length > 0) {
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreisspiegel für Mietwohnungen ' + data.year, col1, this.y);
            } else {
                doc.text('Immobilienpreisspiegel für Immobilien ' + data.year, col1, this.y);
            }
            this.textStyle();

            var columns = ["m²", data.city_name_short, data.state_name, data.country_iso2];
            var rows = [];
            jQuery(data.sizeDataWhg).each(function (k, v) {
                rows.push([v.size + 'm²', (v.city_val !== "-" ? v.city_val + " €" : v.city_val), (v.state_val !== "-" ? v.state_val + " €" : v.state_val), (v.country_val !== "-" ? v.country_val + " €" : v.country_val)]);
            });

            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: this.y + 5, left: col1},
                pageBreak: 'auto',
                tableWidth: col2 - col1 - 10
            });

            empty = false;
        }

        if (jQuery('.chart-rent_whg_bar').length > 0) {
            var chartAspect = 342 / 251;
            this.checkY((90 / chartAspect) + this.y);
            this.headlineSmallStyle();
            doc.text(mietspiegel + ' ' + data.city_name, col2, this.y);
            this.textStyle();

            var chartData = jQuery('.chart-rent_whg_bar')[0].toDataURL("image/png", 1.0);
            doc.addImage(chartData, 'PNG', col2, this.y + 5, col2 - col1 - 10, (col2 - col1 - 10) / chartAspect, null);
            this._y(this.y + (90 / chartAspect) + 10);

            empty = false;
        }

        if (data.sizeDataWhgYears.length > 0) {
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreise Vergleich im Jahr 2011 - ' + data.year, col1, this.y);
            } else {
                doc.text('Immobilienpreise Vergleich im Jahr 2011 - ' + data.year, col1, this.y);
            }
            this.textStyle();

            var columns = ["Jahr", data.city_name_short, data.state_name, data.country_iso2];
            var rows = [];
            var lastSize = 0;
            jQuery(data.sizeDataWhgYears).each(function (k, v) {
                if (lastSize !== v.size) {
                    lastSize = v.size;
                    if (rentBuy === "miete") {
                        rows.push([{
                            content: lastSize + "m² Mietwohnung",
                            colSpan: columns.length,
                            styles: {halign: 'center', valign: "middle", fontStyle: "bold"}
                        }]);
                    } else {
                        rows.push([{
                            content: lastSize + "m² Immobilie",
                            colSpan: columns.length,
                            styles: {halign: 'center', valign: "middle", fontStyle: "bold"}
                        }]);
                    }
                }
                rows.push([v.year, (v.city_val !== "-" ? v.city_val + " €" : v.city_val), (v.state_val !== "-" ? v.state_val + " €" : v.state_val), (v.country_val !== "-" ? v.country_val + " €" : v.country_val)]);
            });

            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: 5, left: col1},
                startY: this.y + 5,
                tableWidth: 190,
                pageBreak: 'auto',
            });

            this._y(doc.lastAutoTable.finalY + 5);
            empty = false;
        }

        if (this.doc.pageCount === 1 && !empty) {
            //this.addPage();
        }
        empty = true;

        if (jQuery('.chart-rent_whg').length > 0) {
            var chartData = jQuery('.chart-rent_whg')[0].toDataURL("image/png", 1.0);
            var chartAspect = 742 / 260;
            this._y(this.y + 5);
            this.checkY((170 / chartAspect) + this.y);
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Entwicklung der Mietpreise für Wohnungen in ' + data.city_name, col1, this.y);
            } else {
                doc.text('Entwicklung der Immobilienpreise für Immobilien Wohnungen in ' + data.city_name, col1, this.y);
            }
            this.textStyle();

            this._y(this.y + 5);
            doc.addImage(chartData, 'PNG', col1 + 10, this.y, 170, (170) / chartAspect, null);
            this._y(this.y + (170 / chartAspect) + 10);
            empty = false;
        }

        if (data.whgDistrictPrices.length > 0) {
            var first = data.whgDistrictPrices.slice(0, data.whgDistrictPrices.length / 2);
            var last = data.whgDistrictPrices.slice(data.whgDistrictPrices.length / 2);

            var columns = ["Stadtteil", "€ / m²", " ", "Stadtteil", "€ / m²"];
            var rows = [];

            for(var idx = 0; idx < data.whgDistrictPrices.length; idx += 2) {
                if(data.whgDistrictPrices[idx+1] !== undefined) {
                    rows.push([data.whgDistrictPrices[idx].district, data.whgDistrictPrices[idx].price + " €", " ", data.whgDistrictPrices[idx+1].district, data.whgDistrictPrices[idx+1].price + " €"]);
                } else {
                    rows.push([data.whgDistrictPrices[idx].district, data.whgDistrictPrices[idx].price + " €", " ", "", ""]);
                }
            }

            this.checkY(this.y);

            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreise für Wohnungen in den verschiedenen Stadtteilen von ' + data.city_name, col1, this.y);
            } else {
                doc.text('Quadratmeterpreise für Eigentumswohnungen in den verschiedenen Stadtteilen von ' + data.city_name, col1, this.y);
            }
            this.textStyle();

            this._y(this.y + 10);
            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: 5, left: col1},
                startY: this.y,
                pageBreak: 'auto',
                //tableWidth: col2-col1-10
            });
            /*var rows = [];
            jQuery(last).each(function(k, v) {
                rows.push([v.district, v.price+" €"]);
            });
            doc.autoTable(columns, rows, {
                margin: {top: 0, left:col2},
                startY: this.y,
                pageBreak: 'auto',
                tableWidth: col2-col1-10
            });*/
            empty = false;
            this._y(doc.lastAutoTable.finalY + 5);
        }

        // Häuser
        this._y(this.y + 60);
        if (this.doc.pageCount === 2 && !empty) {
            //this.addPage();
        }

        this.checkY(this.y + 60);

        empty = true;

        if (data.sizeDataHaus.length > 0) {
            this.checkY(this.y + 100);
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreisspiegel für Häuser ' + data.year, col1, this.y);
            } else {
                doc.text('Immobilienpreisspiegel für Häuser ' + data.year, col1, this.y);
            }
            this.textStyle();

            var columns = ["m²", data.city_name_short, data.state_name, data.country_iso2];
            var rows = [];
            jQuery(data.sizeDataHaus).each(function (k, v) {
                rows.push([v.size + 'm²', (v.city_val !== "-" ? v.city_val + " €" : v.city_val), (v.state_val !== "-" ? v.state_val + " €" : v.state_val), (v.country_val !== "-" ? v.country_val + " €" : v.country_val)]);
            });

            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: 5, left: col1},
                startY: this.y + 5,
                pageBreak: 'auto',
                tableWidth: col2 - col1 - 10
            });

            empty = false;
        }

        var chartAspect = 342 / 251;
        if (jQuery('.chart-rent_haus_bar').length > 0) {
            this.checkY((90 / chartAspect) + this.y);
            this.headlineSmallStyle();
            doc.text(mietspiegel + ' ' + data.city_name, col2, this.y);
            this.textStyle();

            var chartData = jQuery('.chart-rent_haus_bar')[0].toDataURL("image/png", 1.0);
            doc.addImage(chartData, 'PNG', col2, this.y + 5, col2 - col1 - 10, (col2 - col1 - 10) / chartAspect, null);
            this._y(this.y + (90 / chartAspect) + 10);

            empty = false;
        } else if (data.sizeDataHaus.length > 0) {
            // we need y offset
            this._y(this.y + (90 / chartAspect) + 10);
        }

        if (data.sizeDataHausYears.length > 0) {
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreise Vergleich im Jahr 2011 - ' + data.year, col1, this.y);
            } else {
                doc.text('Immobilienpreise Vergleich im Jahr 2011 - ' + data.year, col1, this.y);
            }
            this.textStyle();

            var columns = ["Jahr", data.city_name_short, data.state_name, data.country_iso2];
            var rows = [];
            var lastSize = 0;
            jQuery(data.sizeDataHausYears).each(function (k, v) {
                if (lastSize !== v.size) {
                    lastSize = v.size;
                    rows.push([{
                        content: lastSize + "m² Haus",
                        colSpan: columns.length,
                        styles: {halign: 'center', valign: "middle", fontStyle: "bold"}
                    }]);

                }
                rows.push([v.year, (v.city_val !== "-" ? v.city_val + " €" : v.city_val), (v.state_val !== "-" ? v.state_val + " €" : v.state_val), (v.country_val !== "-" ? v.country_val + " €" : v.country_val)]);
            });
            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: 5, left: col1},
                startY: this.y + 5,
                tableWidth: 190,
                pageBreak: 'auto'
            });
            this._y(doc.lastAutoTable.finalY + 5);
            empty = false;
        }

        if (this.doc.pageCount === 3 && !empty) {
            //this.addPage();
        }
        empty = true;

        if (jQuery('.chart-rent_haus').length > 0) {
            var chartData = jQuery('.chart-rent_haus')[0].toDataURL("image/png", 1.0);
            var chartAspect = 742 / 260;
            this._y(this.y + 5);
            this.checkY((170 / chartAspect) + this.y);
            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Entwicklung der Mietpreise für Häuser in ' + data.city_name, col1, this.y);
            } else {
                doc.text('Entwicklung der Immobilienpreise für Häuser in ' + data.city_name, col1, this.y);
            }
            this.textStyle();

            this._y(this.y + 5);
            doc.addImage(chartData, 'PNG', col1 + 10, this.y, 170, (170) / chartAspect, null);
            this._y(this.y + (170 / chartAspect) + 10);

            empty = false;
        }

        if (data.hausDistrictPrices.length > 0) {
            var first = data.hausDistrictPrices.slice(0, data.hausDistrictPrices.length / 2);
            var last = data.hausDistrictPrices.slice(data.hausDistrictPrices.length / 2);

            var columns = ["Stadtteil", "€ / m²", " ", "Stadtteil", "€ / m²"];
            var rows = [];

            for(var idx = 0; idx < data.hausDistrictPrices.length; idx += 2) {
                if(data.hausDistrictPrices[idx+1] !== undefined) {
                    rows.push([data.hausDistrictPrices[idx].district, data.hausDistrictPrices[idx].price + " €", " ", data.hausDistrictPrices[idx+1].district, data.hausDistrictPrices[idx+1].price + " €"]);
                } else {
                    rows.push([data.hausDistrictPrices[idx].district, data.hausDistrictPrices[idx].price + " €", " ", "", ""]);
                }
            }
            this.checkY(this.y);

            this.headlineSmallStyle();
            if (rentBuy === "miete") {
                doc.text('Mietpreise für Häuser in den verschiedenen Stadtteilen von ' + data.city_name, col1, this.y);
            } else {
                doc.text('Quadratmeterpreise für Häuser in den verschiedenen Stadtteilen von ' + data.city_name, col1, this.y);
            }
            this.textStyle();

            this._y(this.y + 5);
            autoTable(doc,{
                columns: columns,
                body: rows,
                margin: {top: 5, left: col1},
                startY: this.y,
                pageBreak: 'auto',
                //tableWidth: col2-col1-10
            });
            /*var rows = [];
            jQuery(last).each(function(k, v) {
                rows.push([v.district, v.price+" €"]);
            });
            doc.autoTable(columns, rows, {
                margin: {top: 0, left:col2},
                startY: this.y,
                pageBreak: 'auto',
                tableWidth: col2-col1-10
            });*/
            empty = false;
        }

        //if(empty) {
        //    this.doc.deletePage(this.doc.pageCount);
        //} else {
        //    this.footer();
        //}
        this.footer();

        if (doc.internal.getNumberOfPages() > 0) {
            doc.save(name + '.pdf');
        } else {
            alert("Leider steht dieses PDF aktuell nicht zum Download zur Verfügung.");
            return false;
        }
    },

    _y: function (y) {
        this.y = y;
        if (this.y + 20 > this.doc.internal.pageSize.height) {
            this.addPage();
        }
    },
    checkY: function (y) {
        if (y + 20 > this.doc.internal.pageSize.height) {
            this.addPage();
        }
    },
    addPage: function () {
        this.footer();
        this.doc.addPage();
        this.doc.pageCount++;
        this.y = this.startY;
    },
    headlineStyle: function () {
        this.doc.setFont(this.fontName, "", "bold");
        this.doc.setFontSize(16);
    },
    headlineSmallStyle: function () {
        this.doc.setFont(this.fontName, "", "bold");
    },
    textStyle: function () {
        this.doc.setFont(this.fontName, "", "normal");
        this.doc.setFontSize(10);
    },
    footer: function () {
        this.doc.text('ein Service von © wohnungsboerse.net', 140, 285);
        this.doc.text((this.rentBuy == "miete" ? 'Mietspiegel' : 'Immobilienpreisspiegel') + ' ' + this.cityName + ' Stand ' + this.date, 10, 285);
    }
}
